import React, {
    useState,
    useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';


import classNames from 'classnames';
import stubImg from './stub.jpg';


export function DishPicture(props) {
    const {
        alt,
        imageUrl,
        imageUrlDesktop,
        useLazyLoading,
    } = props;

    const [imageLoadingErrorsCount, setImageLoadingErrorsCount] = useState(0);

    // quick kostyl for squidgame lp
    const isSquidgamePage = window.location.pathname.includes('/squid-game');

    const handleImageLoadError = useCallback(() => {
        setImageLoadingErrorsCount((count) => count + 1);
    }, []);

    const desktopImg = (() => {
        if (imageLoadingErrorsCount === 1) return imageUrl;
        if (imageLoadingErrorsCount === 2) return stubImg;
        return imageUrlDesktop;
    })();

    const mobImg = (() => {
        if (imageLoadingErrorsCount === 1) return imageUrlDesktop;
        if (imageLoadingErrorsCount === 2) return stubImg;
        return imageUrl;
    })();

    const dishImageClasses = classNames({
        ny__dish__image: true,
        'ny__dish__image--leftOriented': isSquidgamePage,
    });

    return (
        <picture
            className="ny__dish__image-root"
        >
            <source media="(max-width: 1023px)" srcSet={mobImg} />
            <source media="(min-width: 1024px)" srcSet={desktopImg} />
            {useLazyLoading ? (
                <img
                    key={imageLoadingErrorsCount}
                    className={dishImageClasses}
                    alt={alt}
                    onError={handleImageLoadError}
                />
            ) : (
                <LazyLoadImage
                    threshold={400}
                    key={imageLoadingErrorsCount}
                    className={dishImageClasses}
                    alt={alt}
                    onError={handleImageLoadError}
                />
            )}
        </picture>
    );
}

DishPicture.propTypes = {
    useLazyLoading: PropTypes.bool.isRequired,
    alt: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    imageUrlDesktop: PropTypes.string.isRequired,
};


